// Copyright 2025, University of Maryland, All Rights Reserved
import { JobsComponent } from '@umd-dit-ai-workspace/jobs-component';
import '@umd-dit-ai-workspace/jobs-component/dist/index.css';
import { useAuth } from '@umd-dit-ai-workspace/workspaces-component';
import { apiClient } from '@/api/api-client';

export default function Jobs() {
  const { selectedOrganizationId, selectedWorkspaceId, isAdmin } = useAuth();

  return (
    <div className="container mx-auto px-4 py-4">
      <JobsComponent
        app_id="legislative-review"
        org_id={selectedOrganizationId || 'demo-org'}
        ws_id={selectedWorkspaceId || 'demo-workspace'}
        isAdmin={isAdmin}
        metadata_fields={{ "bill_number": "Bill Number" }}
        apiInstance={apiClient.getAxiosInstance()}
      />
    </div>
  );
}